import React, { useState } from 'react'
import { POST_TYPES, TYPE_ORDER, makePost, designName, designsFor } from '../data/postTypes'
import { FAMILIES } from '../render/families'
import { COLOURWAYS } from '../render/colourways'
import { postTheme } from '../render/render'
import PostCanvas from './PostCanvas'

// Every design, in both formats, on one page: for checking the whole set at
// a glance (Social page with ?sheet=1, local and staging only). A layout
// shows in its own theme first.
const DesignSheet = ({ trade, kit, onClose }) => {
  const [colourway, setColourway] = useState('first')
  const cw = (family, type, layout) => {
    if (colourway === 'brand' && kit.accent) return 'brand'
    const list = COLOURWAYS[family]
    if (colourway === 'last') return list[list.length - 1].id
    if (family === 'layouts') return POST_TYPES[type].layouts[layout].theme
    return list[0].id
  }
  return (
    <div className="sx-sheet-page" role="dialog" aria-label="Every design">
      <div className="sx-sheet-page-head">
        <strong>Every design</strong>
        {['first', 'last', 'brand'].map(id => (
          <button key={id} type="button" className={`sx-btn${colourway === id ? ' is-on' : ''}`} onClick={() => setColourway(id)}>{id === 'brand' ? 'Your brand' : id === 'first' ? 'As designed' : 'Last colourway'}</button>
        ))}
        <button type="button" className="sx-btn" onClick={onClose}>Close</button>
      </div>
      {TYPE_ORDER.map(type => (
        <div key={type} className="sx-sheet-row">
          <div className="sx-sheet-row-name">{POST_TYPES[type].label}</div>
          <div className="sx-sheet-row-items">
            {designsFor(type).map(({ family, layout }) => {
              const post = makePost(type, { trade, family, layout, colourway: cw(family, type, layout), brandColour: kit.accent, photos: type === 'beforeAfter' ? {} : undefined })
              const theme = postTheme(post, { kit })
              return (
                <div key={layout || family} className="sx-sheet-cell">
                  <div className="sx-sheet-cell-name">{layout ? designName(type, family, layout) : `${FAMILIES[family].name}: ${designName(type, family)}`}</div>
                  <div className="sx-sheet-cell-art">
                    <PostCanvas post={post} theme={theme} format="post" width={200} thumb />
                    <PostCanvas post={{ ...post, format: 'story' }} theme={theme} format="story" width={140} thumb />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}

export default DesignSheet
